import { render, staticRenderFns } from "./moreOXTOU.vue?vue&type=template&id=0aa4f4ec&lang=pug&"
import script from "./moreOXTOU.vue?vue&type=script&lang=js&"
export * from "./moreOXTOU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports